export const ivideon = {
  "ivideon.getLicensesReport": "ivideon.getLicensesReport",
  "ivideon.getReport": "ivideon.getReport",
  "ivideon.sync": "ivideon.sync",
  "ivideon.logout": "ivideon.logout",
  "ivideonGroups.acceptGroup.sale": "ivideonGroups.acceptGroup.sale",
  "ivideonGroups.acceptGroup.service": "ivideonGroups.acceptGroup.service",
  "ivideon.getDealerDocs": "ivideon.getDealerDocs",
  "ivideon.getDealers": "ivideon.getDealers",
  "ivideon.getLicenses": "ivideon.getLicenses",
  "ivideonGroups.createDealerLicenses": "ivideonGroups.createDealerLicenses",
  "ivideonGroups.deacceptGroups": "ivideonGroups.deacceptGroups",
  "ivideonGroups.getGroups.sale": "ivideonGroups.getGroups.sale",
  "ivideonGroups.getGroups.service": "ivideonGroups.getGroups.service",
  "ivideon.getCameraTariffs": "ivideon.getCameraTariffs",
  "ivideon.createIvideonCameraTariff": "ivideon.createIvideonCameraTariff",
  "ivideon.updateIvideonCameraTariff": "ivideon.updateIvideonCameraTariff",
  "ivideon.deleteIvideonCameraTariff": "ivideon.deleteIvideonCameraTariff",
} as const;
